import React, { useContext } from 'react';
import _ from 'lodash';
import { WizardContext } from 'wmic-pe-portals-custom-wizard-react';
import { JURISDICTIONS, PAConstants } from 'wmic-pe-portals-utils-js';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WMICHeading } from 'wmic-pe-components-platform-react';
import WMICPACoverageUtil from 'wmic-pe-capability-gateway-common-pa-react/util/WMICPACoverageUtil';
import { TranslatorContext } from '@jutro/legacy/locale';
import WMICPolicyDriverEndorsementComponent from './WMICPolicyDriverEndorsementComponent/WMICPolicyDriverEndorsementComponent';
import metadata from './WMICPAPolicyDriverEndorsements.metadata.json5';
import messages from './WMICPAPolicyDriverEndorsements.messages';

function WMICPAPolicyDriverEndorsements(props) {
    const { id } = props;
    const {
        wizardData: { policyVM, selectedPolicyTermNumber },
    } = useContext(WizardContext);
    const translator = useContext(TranslatorContext);

    const selectedTerm = _.find(
        _.get(policyVM, 'periods.value'),
        period => period.termNumber_WMIC === selectedPolicyTermNumber
    );
    const coveragesVM = _.get(policyVM, `lobs.personalAuto.coverageDTOs.driverEndorsements`);
    const baseState = _.get(policyVM, 'lobs.personalAuto.baseState.value');
    const rateAsOfDate = _.get(selectedTerm, 'rateAsOfDate');

    const getCov28Heading = jurisdiction => {
        if ([JURISDICTIONS.ALBERTA, JURISDICTIONS.YUKON].includes(jurisdiction)) {
            return messages.reductionOfCoverage_AB_YT;
        }

        if (jurisdiction == JURISDICTIONS.ONTARIO) {
            return messages.reductionOfCoverage_ON;
        }

        return messages.reductionOfCoverage;
    };

    const getDriverEndorsementHeading = covPublicId => {
        let heading = '';

        switch (covPublicId) {
            case PAConstants.accidentWaiverCovPublicId:
            case PAConstants.accidentWaiverMtcCovPublicId:
            case PAConstants.minorConvictionWaiver39bPublicId:
                return _.find(coveragesVM.value, { publicID: covPublicId })?.name;
            case PAConstants.reducAmtForNamedCov_28_PublicId:
                heading = getCov28Heading(baseState?.code);
                break;
            case PAConstants.reducAmtForNamedCov_28A_PublicId:
                heading = messages.excludedDriver;
                break;
            default:
                return '';
        }

        return translator(heading);
    };

    const renderDriverEndorsements = () => {
        const policyDrivers = policyVM?.lobs?.personalAuto?.driverDTOs?.value;

        return coveragesVM?.value
            ?.filter(
                endorsement =>
                    WMICPACoverageUtil.getEligibleDriversForEndorsement(endorsement, policyDrivers, baseState.code).length > 0
            )
            ?.map(endorsement => (
                <>
                    <WMICHeading
                        id={`${id}_heading`}
                        underlined
                        title={getDriverEndorsementHeading(endorsement.publicID)}
                        className="gw-mb-3"
                    />
                    <WMICPolicyDriverEndorsementComponent
                        id={endorsement.coverageUniqueID}
                        driverEndorsement={endorsement}
                        offeredCoverages={coveragesVM}
                        policyVM={policyVM}
                        baseState={baseState}
                        rateAsOfDate={rateAsOfDate}
                    />
                </>
            ));
    };

    const overrideProps = {
        '@field': {
            readOnly: true,
        },
        driverEndorsementsCoveragesContainer: {
            content: renderDriverEndorsements(),
        },
    };

    const resolvers = {
        resolveComponentMap: {},
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

export default WMICPAPolicyDriverEndorsements;
